import React from 'react';
import './ContactPage.css';
import emoji7 from '../../assets/emoji7.png';
import iconPushpin from '../../assets/icon_pushpin.png';
import iconMail from '../../assets/icon_mail.png';

const ContactsPage = () => {
    return (
        <div className="contacts-page-container">
            <div className="contacts-main-container">
                <div className="main-div">
                    <div className="main-text">Please get in touch!</div>
                    <div className="main-text2">We'd love to hear from you.</div>
                </div>
                <div className="description-div">
                    <div> We'd love to hear from you. Tell us how we're doing and what we could do to bring more gratitude into your life.</div>
                </div>
                <div className="address-div">
                    <img className="pushpin-icon" src={iconPushpin} />
                    <div className="address-text">
                        <div>Thankfully Inc</div>
                        <div>c/o WeWork</div>
                        <div>200 Broadway</div>
                        <div>NY, NY 10038</div>
                    </div>
                </div>
                <div className="link-div">
                    <img className="mail-icon" src={iconMail}/>
                    <a className="contact-link" href="mailto:hello@thankfully.com?subject=Hello">hello@thankfully.com</a>
                </div>
            </div>        
        </div>
    )
}

export default ContactsPage;


// WEBPACK FOOTER //
// ./src/components/ContactPage/ContactPage.js